import React from 'react';
import { Container, Section } from '../ui/Section';
import { ButtonLink, ButtonExternal } from '../ui/Button';
import { EventCard } from '../events/EventCard';
import { Reveal, stagger } from '../motion/Reveal';
import { DoodleScatter } from '../brand/DoodleScatter';
import { visibleSpecialEvents } from '../../data/events';
import { externalLinks } from '../../data/site';
export function UpcomingEvents() {
  return <Section className="relative overflow-hidden bg-brand-blue py-16 sm:py-20" labelledBy="events-heading" data-id="element-189" data-mp="awihqm0xw869">
      {/* Light-blue panel: scatter uses navy, cream, and yellow only. */}
      <DoodleScatter tone="blue" seed="upcoming-events" data-id="element-190" data-mp="1xoe4bp6yhj7" />
      <Container className="relative" data-id="element-191" data-mp="1usjaw8n48yz">
        <Reveal data-id="element-192" data-mp="5xp3ushqqf5k">
          <div className="max-w-2xl" data-id="element-193" data-mp="5zi8y3cpgrbg">
            <h2 id="events-heading" className="font-display text-3xl font-extrabold leading-tight tracking-tight text-brand-navy sm:text-5xl" data-id="element-194" data-mp="5wdwyjt00ra8">
              What’s happening at BCM
            </h2>
            <p className="mt-4 font-sans text-[17px] leading-relaxed text-ink" data-id="element-195" data-mp="39dh8nhb3ho8y">
              Start with a worship night, join us during Welcome Week, or connect with someone who can
              help you find your place.
            </p>
          </div>
        </Reveal>

        <ul className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-196" data-mp="3dfkpymkg3n25">
          {visibleSpecialEvents.map((event, index) => <Reveal key={event.id} as="li" delay={stagger(index)} className="h-full" data-id="element-197" data-mp="2ppqarycnlmeq" data-mpi={index}>
              <EventCard event={event} data-id="element-198" data-mp="2loen3ydcbb96" />
            </Reveal>)}
        </ul>

        <Reveal delay={0.1} data-id="element-199" data-mp="2lmlb03jyjyts">
          <div className="mt-9 flex flex-col gap-3 sm:flex-row" data-id="element-200" data-mp="2zgcoto4q24vb">
            <ButtonLink to="/events" data-id="element-201" data-mp="2zhnr1jiir4kb">See All Events</ButtonLink>
            <ButtonExternal href={externalLinks.getConnectedForm} variant="secondary" data-id="element-202" data-mp="2uob55h585bv9">
              Get Event Updates
            </ButtonExternal>
          </div>
        </Reveal>
      </Container>
    </Section>;
}